import { makeAutoObservable } from "mobx";
import ApiDataAnalitic from "./ApiDataAnalitic";
import stateAnalyticApp from "../state/stateAnalyticApp";
import stateAnalyticCompany from "../state/stateAnalyticCompany";
class AnalyticIncidentData {
  constructor() {
    makeAutoObservable(this);
  }
  incidents = null;
  incidentCard = {
    visible: false,
  };
  index = 0;
  nameFildReport = [
    "taskid",
    "device_name",
    "place_name",
    "name_production",
    "device_id",
    "production_id",
    "place_id",
  ];
  errorMessage = "";

  incidentCardUpdate = (name, time, count) => {
    this.incidentCard = {
      ...this.incidentCard,
      name: name,
      time: time,
      count: 0,
      data: [],
      visible: false,
    };
  };
  incidentCardVisible = (boolean) => {
    this.incidentCard = {
      ...this.incidentCard,
      visible: boolean,
    };
  };
  setParameters = (name, value) => {
    this[`${name}`] = value;
  };

  changeVisibleProduction = (prod) => {
    const prodID = this.incidentCard.data.find((p) => prod === p.production_id);
    if (prodID) prodID.visible = !prodID.visible;
  };

  getLine = (prod, line) => {
    const prodID = this.incidentCard.data.find((p) => prod === p.production_id);
    if (prodID) {
      const lineID = prodID.places.find((l) => line === l.place_id);
      return lineID;
    }
  };

  changeVisibleLine = (prod, line) => {
    const lineID = this.getLine(prod, line);
    if (lineID) lineID.visible = !lineID.visible;
  };

  changeFilterDevice = (prod, line, device) => {
    const lineID = this.getLine(prod, line);
    if (device) {
      const deviceID = lineID.data.find(
        (d) => d.device_id === device.device_id
      );
      if (deviceID) lineID.filter_device = deviceID.device_name;
      return (lineID.data = [
        ...lineID.data.filter((d) => d.device_id === device.device_id),
      ]);
    } else {
      lineID.filter_device = null;
      return (lineID.data = lineID.originalData);
    }
  };

  // Собираем структуру инцидента
  createStructureCardIncident = (data) => {
    data.map((i) => {
      const newDevice = {
        device_name: i.device_name,
        device_id: i.device_id,
        taskid: i.taskid,
        index: this.index,
      };
      this.incidentCard.count = this.incidentCard.count + 1;
      //Ищем площадку
      const poductionID = this.incidentCard.data.find(
        (p) => p.production_id === i.production_id
      );
      // Если площадки нет
      if (!poductionID) {
        this.incidentCard.data = [
          ...this.incidentCard.data,
          {
            name_production: i.name_production,
            production_id: i.production_id,
            production_errors: 1,
            visible: true,
            places: [
              {
                place_name: i.place_name,
                place_id: i.place_id,
                place_errors: 1,
                visible: false,
                filter_device: null,
                originalData: [newDevice],
                data: [newDevice],
              },
            ],
          },
        ];
        // Если площадка есть
      } else {
        // Ищем линию
        const placeID = poductionID.places.find(
          (l) => l.place_id === i.place_id
        );
        // Если линии нет
        if (!placeID) {
          poductionID.production_errors = poductionID.production_errors + 1;
          poductionID.places = [
            ...poductionID.places,
            {
              place_name: i.place_name,
              place_id: i.place_id,
              visible: false,
              place_errors: 1,
              filter_device: null,
              originalData: [newDevice],
              data: [newDevice],
            },
          ];
        } // Если линия есть
        else {
          poductionID.production_errors = poductionID.production_errors + 1;
          placeID.place_errors = placeID.place_errors + 1;
          placeID.data = [...placeID.data, newDevice];
          placeID.originalData = [...placeID.originalData, newDevice];
        }
      }
      this.index++;
    });
  };

  goCardIncident = (e) => {
    this.incidentCardUpdate(e.data, e.total_counter);
    this.incidentCard.data = [];
    this.incidentCard.count = 0;
    this.index = 0;
    this.fetchIncidentCard(this.nameFildReport.join("%2C%20"), e.data);
    this.setParameters("errorMessage", e.data);
    this.incidentCardVisible(true);
  };

  fetchList = async (signal) => {
    stateAnalyticApp.setParameter("isLoading", false);
    try {
      const resData = await ApiDataAnalitic.fetchIncidentSa({
        companyId: stateAnalyticCompany.id_company,
        from: stateAnalyticApp.from_date,
        to: stateAnalyticApp.to_date,
        signal,
      });
      if (resData === undefined) return false;
      if (resData.length === 0) {
        this.setParameters("incidents", resData);
        return true;
      }
      const transformedData = resData.map((d) => ({
        ...d,
        total_counter: ApiDataAnalitic.formatIncidentDowntime(d.total_counter),
      }));
      this.setParameters("incidents", transformedData);
      return true;
    } catch (e) {
      if (e?.isForbidden) {
        stateAnalyticApp.setParameter("noRight", true);
        return false;
      }
      if (e?.code === "ERR_CANCELED" || e?.name === "CanceledError") {
        return false;
      }
      console.error("fetchList incident error", e);
      return false;
    } finally {
      stateAnalyticApp.setParameter("isLoading", true);
    }
  };

  fetchIncidentCard = async (fieldsName, errorData, signal) => {
    stateAnalyticApp.setParameter("isLoading", false);
    try {
      const message = await ApiDataAnalitic.fetchIncidentSa({
        companyId: stateAnalyticCompany.id_company,
        from: stateAnalyticApp.from_date,
        to: stateAnalyticApp.to_date,
        fields_name: fieldsName,
        data: errorData,
        signal,
      });
      if (message) {
        this.incidentCard.data = [];
        this.incidentCard.count = 0;
        this.index = 0;
        this.createStructureCardIncident(message);
      }
      return true;
    } catch (e) {
      if (e?.isForbidden) {
        stateAnalyticApp.setParameter("noRight", true);
        return false;
      }
      if (e?.code === "ERR_CANCELED" || e?.name === "CanceledError") {
        return false;
      }
      console.error("fetchIncidentCard error", e);
      return false;
    } finally {
      stateAnalyticApp.setParameter("isLoading", true);
    }
  };

  resetIncidents = () => {
    this.incidents = null;
    this.incidentCard = { visible: false };
    this.index = 0;
    this.errorMessage = "";
  };
}

export default new AnalyticIncidentData();

